import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ApiService, HttpParamsOptions } from '../api.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { trigger, style, transition, animate } from '@angular/animations';
import { NgZone } from '@angular/core';
import * as _ from 'lodash';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { Config } from 'datatables.net';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2';
import moment from 'moment';

class DataTablesResponse {
	data!: any[];
	draw!: number;
	recordsFiltered!: number;
	recordsTotal!: number;
}

@Component({
	selector: 'app-rma-master',
	templateUrl: './rma-master.component.html',
	styleUrl: './rma-master.component.scss',
	animations: [trigger('enterAnimation', [
		transition(':enter', [
			style({ transform: 'translateY(-100%)', opacity: 0 }),
			animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
		]),
		transition(':leave', [
			style({ transform: 'translateY(0)', opacity: 1 }),
			animate('500ms', style({ transform: 'translateY(-100%)', opacity: 0 }))
		])
	])]
})
export class RMAMasterComponent {

	UserModuleAccess: any = "Full";
	showCard = false;
	colorScheme: any = {
		domain: ['#5AA454', '#ffe417', '#f72119', '#ffa01b', '#690000']
	};
	colorScheme1: any = {
		domain: ['#211bd1', '#ffe417', '#f72119', '#ffa01b', '#690000']
	};
	yAxisTicks: any[] = [0, 300, 600, 900, 1200];
	filterDates = (d: Date | null) => {
		const today = new Date();
		if (d == null) return false;
		return d <= today;
	}
	@ViewChild(DataTableDirective, { static: false }) datatableElement!: DataTableDirective;
	@ViewChild(MatPaginator,) paginator!: MatPaginator;
	baseURL = environment.API_URL + "api/";
	dtOptions: Config = {};
	dataList: any = [];
	user_type: any = "";
	isCompanyIdNull = false;
	accessLoader = false;
	yearList: any[] = [];
	RCodeBlueData: any = [];
	EventFlagDistribution: any;
	MFClosure: any = null;
	mark_for_closure_count: any;
	openCasesDays: any;
	selectedDay: number | null = null;
	constructor(private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService, private zone: NgZone, private datePipe: DatePipe, private http: HttpClient) {
		let yyyy = 2000;
		let currentYear = moment().year();
		while (yyyy <= currentYear) {
			this.yearList.push({ value: yyyy, name: yyyy });
			yyyy += 1;
		}
		this.yearList = this.yearList.reverse();
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.accessLoader = true;
			this.apiService.getUserAccess().subscribe({
				next: (data: any) => {
					this.accessLoader = false;
					try {
						this.user_type = data.res[0].user_type;
						this.cardsFilter.user_id = (data.res[0].UserId);
						let accessObj: any = JSON.parse(data.res[0].UserModuleAccess);
						this.UserModuleAccess = accessObj["HC_dashboard"];

						this.getCompanyWiseData();
					} catch (error) { }
				}, error: (error: any) => {
					this.accessLoader = false;
					this.UserModuleAccess = "NoAccess";
				}
			});
		});
	}

	ngAfterViewInit(): void { }

	ngOnDestroy(): void { }
	vesselLoader = false;

	selectDay(day: number) {
		this.selectedDay = day;
	}

	initDatatable() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			serverSide: true,
			processing: true,
			ordering: false,
			ajax: (dataTablesParameters: any, callback) => {
				let data: any = {
					start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
					end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
					draw: dataTablesParameters.draw,
					start: dataTablesParameters.start,
					length: dataTablesParameters.length,
					searchVal: dataTablesParameters.search.value,
					days: this.openCasesDays || null,
					mark_for_closure: this.MFClosure
				}
				const httpParams: HttpParamsOptions = { data } as HttpParamsOptions;
				console.log(httpParams);
				this.http.post<DataTablesResponse>(this.baseURL + "master_hc_dashboard", data).subscribe({
					next: (response: any) => {
						this.dataList = response.data_list;
						this.mark_for_closure_count = response.mark_for_closure_count;
						callback({
							recordsTotal: response.recordsTotal,
							recordsFiltered: response.recordsFiltered
						});
					}, error: (error: any) => {
						if (error.status == 401) { return }
						this.toastr.error("Hmmm Something went wrong.", 'Error!!!', {
							timeOut: 5000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		}
	}

	getCompanyWiseData() {
		this.initDatatable();
		this.getEventFlagDistributionByDoctors();
		this.getRmaCodeBlue();
	}

	activeCases: any = [];
	isListFinished: boolean = false;
	activeCasesLoading: boolean = false;
	tableparams = {
		start: 0,
		length: 10,
	};
	ActiveCasesExcelLoader = false;
	ActiveCasesExcelExcelName = "Active Cases.xlsx";

	getRmaCodeBlue() {
		this.apiService.rma_dashboard_code_blue_section().subscribe({
			next: (res) => {
				let data: any = res;
				this.RCodeBlueData = data.data_list;
			}, error: (error) => {
				this.RCodeBlueData = [];
				if (error.status == 401) { return }
				this.toastr.error("Unable to Fetch Data ", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	getEventFlagDistributionByDoctors() {
		let data = {
			start_date: this.apiService.getDateStringFromDate(this.cardsFilter.start_date),
			end_date: this.apiService.getDateStringFromDate(this.cardsFilter.end_date),
		}

		this.apiService.event_flag_distribution_by_doctors(data).subscribe(res => {
			let data: any = res;
			this.EventFlagDistribution = data.data_list;

		}, (error) => {
			this.EventFlagDistribution = [];
			if (error.status == 401) { return }
			this.toastr.error("Unable to Fetch Data ", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
		});
	}

	refreshTable() {
		this.datatableElement.dtInstance.then((dtInstance) => {
			dtInstance.draw();
		});
	}

	MarkedForClosure(event: any): void {
		if (event == 7) {
			this.openCasesDays = "7+";
		}
		if (event == 14) {
			this.openCasesDays = "14+";
		}
		if (event == 21) {
			this.openCasesDays = "21+";
		}
		if (event == 28) {
			this.openCasesDays = "28+";
		}

		this.refreshTable();
		this.initDatatable();

	}

	pagetitle = "RMA";
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: this.apiService.getDashboardURL("hc"),
			name: this.pagetitle
		}
	];
	dateFilter = this.apiService.getDefaultDateRange(true);
	currentAccordion = "InvoiceModuleAlerts";
	top_5_med_cases: any[] = [];
	top5CasesLoader = false;
	cardsFilter: any = {
		user_id: null,
		start_date: this.apiService.getDefaultDateRange1Week(false).start_date,
		end_date: this.apiService.getDefaultDateRange1Week(false).end_date,
		year: moment().year()
	}
}
